import invokeClient from './invokeClient';
export const gotoPage = (params) => {
    return invokeClient.invoke({
        functionName: 'gotoPage',
        params: JSON.stringify(params)
    });
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ290b1BhZ2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9saWIvZ290b1BhZ2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxZQUFZLE1BQU0sZ0JBQWdCLENBQUM7QUFFMUMsTUFBTSxDQUFDLE1BQU0sUUFBUSxHQUFHLENBQUMsTUFBTSxFQUFFLEVBQUU7SUFDakMsT0FBTyxZQUFZLENBQUMsTUFBTSxDQUFDO1FBQ3pCLFlBQVksRUFBRSxVQUFVO1FBQ3hCLE1BQU0sRUFBRSxJQUFJLENBQUMsU0FBUyxDQUFDLE1BQU0sQ0FBQztLQUMvQixDQUFDLENBQUM7QUFDTCxDQUFDLENBQUMifQ==